import React from "react";
import { Box, Text, Typography, HStack } from "components/ui";
import ESGMetricCard from "./ESGMetricCard";
import { SustainabilityDashboardRead } from "store/abcoApi";

interface ESGImprovementsSectionProps {
	data: SustainabilityDashboardRead
}

const ESGImprovementsSection: React.FC<ESGImprovementsSectionProps> = ({
	data,
}) => {
	const currentYear = data.currentYear || {};
	const previousYear = data.previousYear || {};

	console.log({data})
	const handleInfoClick = (metric: string) => {
		// TODO: Implement info modal or tooltip
		console.log(`Info clicked for ${metric}`);
	};

	// Helper function to check if a metric has meaningful data
	const hasMeaningfulData = (currentValue: number, previousValue: number) => {
		return (currentValue || 0) > 0 || (previousValue || 0) > 0;
	};

	return (
		<Box>
			<Box justifyContent="center" gap={20} alignItems="center" mb={24}>
				<Typography.H3>Contributions and reductions</Typography.H3>
				<Typography sx={{ fontFamily: "calibri", textAlign: "center" }}>
					{data.currentYear?.totalOrders} orders have generated the following ESG improvements this financial year
				</Typography>
			</Box>
			
			<Box>
				{/* Carbon Offset Tons - only show if there's meaningful data */}
				{hasMeaningfulData(currentYear.carbonOffsetTons || 0, previousYear.carbonOffsetTons || 0) && (
					<ESGMetricCard
						title="Carbon Offset Tons"
						currentValue={currentYear.carbonOffsetTons || 0}
						previousValue={previousYear.carbonOffsetTons || 0}
						unit=" tons"
						onInfoClick={() => handleInfoClick("carbonOffsetTons")}
						tooltipText="Tonnes of CO2e offset through Greenfleet by the purchase of Enviroplus and Puregiene paper products"
					/>
				)}
				
				{/* Water Contribution - only show if there's meaningful data */}
				{hasMeaningfulData(currentYear.litresOfCleanDrinkingWater || 0, previousYear.litresOfCleanDrinkingWater || 0) && (
					<ESGMetricCard
						title="Made Blue Water Contribution"
						currentValue={currentYear?.litresOfCleanDrinkingWater || 0}
						previousValue={previousYear.litresOfCleanDrinkingWater || 0}
						unit=" litres"
						onInfoClick={() => handleInfoClick("waterContribution")}
						tooltipText="Litres of water contributed to the Made Blue Foundation through the purchase of i-Mops"
					/>
				)}

				{/* Books Donated - only show if there's meaningful data */}
				{hasMeaningfulData(currentYear.booksDonated || 0, previousYear.booksDonated || 0) && (
					<ESGMetricCard
						title="Ilf Books Donated"
						currentValue={currentYear?.booksDonated || 0}
						previousValue={previousYear.booksDonated || 0}
						unit=" books"
						onInfoClick={() => handleInfoClick("books donated")}
						tooltipText="Books contributed to the ILF Book Supply Program helping to promote literacy in remote First Nations Communities"
					/>
				)}


				{hasMeaningfulData(currentYear.recycledContentKg || 0, previousYear.recycledContentKg || 0) && (
					<ESGMetricCard
						title="Estimated Recycled Content"
						currentValue={currentYear?.recycledContentKg || 0}
						previousValue={previousYear.recycledContentKg || 0}
						unit=" kg"
						onInfoClick={() => handleInfoClick("recycled content")}
						tooltipText="Estimated kgs of at least one cycle of plastic potentially diverted from landfill by purchasing bin liners with PCR"
					/>
				)}

				{hasMeaningfulData(currentYear.sugarcaneBagasseKg || 0, previousYear.sugarcaneBagasseKg || 0) && (
					<ESGMetricCard
						title="Sugarcane Waste Utilised"
						currentValue={currentYear?.sugarcaneBagasseKg || 0}
						previousValue={previousYear.sugarcaneBagasseKg || 0}
						unit=" kg"
						onInfoClick={() => handleInfoClick("recycled content")}
						tooltipText="Kg’s of sugarcane waste utilised from purchase of paper from the Enviroplus ECO Range"
					/>
				)}
			</Box>
			
			<Box  >
				<HStack justifyContent="center" gap={16} alignItems="center">
					<HStack alignItems="center" gap={6}>
						<Box width={16} height={2} bgColor="#FF6B35" borderRadius={1} />
						<Text fontSize={12} color="#666">
							Previous year
						</Text>
					</HStack>
					<HStack alignItems="center" gap={6}>
						<Box width={16} height={8} bgColor="#007AFF" borderRadius={2} />
						<Text fontSize={12} color="#666">
							Current year
						</Text>
					</HStack>
				</HStack>
			</Box>
		</Box>
	);
};

export default ESGImprovementsSection;
